import * as React from 'react';

import Room from 'src/state/Room';
import RoomPage from 'src/state/RoomPage';

import GameRow from 'src/ui/GameRow';
import Section from 'src/ui/Section';

import App from 'src/state/App';

const AddGame: React.SFC<{
  store: App.Store,
  room: Room,
  page: RoomPage,
}> = (
  ({store, room, page}) => {
    return (
      <Section
        store={store}
        page={page}
        title="Add Game"
        bodyPadding="0"
      >
        <GameRow
          store={store}
          room={room}
          page={page}
          id="GameRow-AddGame"
          data={{ type: 'selectable' }}
        />
      </Section>
    );
  }
);

export default AddGame;



// WEBPACK FOOTER //
// ./src/ui/AddGame/index.tsx